export type RegistrationStep = keyof typeof stepCopy;

export const stepCopy = {
  firstEntry: {
    title: 'Set a PIN',
    message:
      'In order to continue you must set a PIN. You will be asked to enter this PIN each time you return to the app after even short periods of inactivity, in order to protect the sensitive data it contains.',
  },
  secondEntry: {
    title: 'Re-enter PIN',
    message: 'Please re-enter the same PIN.',
  },
  success: {
    title: 'PIN saved',
    message: 'You will be asked for this PIN regularly.',
  },
};
